import React from "react";
import Countdown from "react-countdown";

const renderer = ({ days, hours, minutes, completed }) => {
  if (completed) {
    return <span>Event started</span>;
  }

  // If less than 1 day, show hours and minutes
  if (days === 0) {
    return (
      <span>
        {hours > 0 && `${hours} hour${hours > 1 ? "s" : ""} `}
        {minutes > 0 && `${minutes} minute${minutes > 1 ? "s" : ""}`}
      </span>
    );
  }

  // Else show days
  return <span>{days} day{days > 1 ? "s" : ""}</span>;
};

export default function EventCountdown({ targetDate }) {
  return <Countdown date={targetDate} renderer={renderer} />;
}
